<template lang="pug">
div.process-content
  div.content-area
    div.left-content
      h1.label 经典案例
      p.tips 经典案例模式中你将作为政府或企业的公关人员，处理政府或企业的日常形象公关事务、关系公关事务以及非常时期的危机公关事务。
      button.frame(@click="gocase") 开始实训
    div.right-content
      h1.label 案例自定义
      p.tips 案例自定义模式中，你可以将实事热点、新近案例上传至实训软件中，并根据其发展演变的历程设计实训题目，在社区中进行分享讨论。
      button.frame(@click="gocustom") 开始实训
</template>

<script>
export default {
  name: "home",
  methods: {
    gocase() {
      this.$router.push("/Student/case_list");
    },
    gocustom() {
      this.$router.push("/Student/custom-case");
    }
  }
};
</script>

<style lang="stylus" scoped>
.process-content
  width 100%
  margin 0 auto
  .content-area
    width 1366px
    margin 0 auto
    display flex
    justify-content center
    align-items Center
    .left-content
      width 350px
      height 300px
      margin 150px 0 0
      background rgba(76, 76, 76, 0.91)
      border-radius 8px
      border 1px solid rgba(151, 151, 151, 1)
    .label
      padding 48px 24px 0
      text-align left
      font-size 20px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color #FFFFFF
    .tips
      font-size 14px
      font-family MicrosoftYaHeiUI
      color #FFFFFF
      text-align left
      margin 26px 24px
    .frame
      width 160px
      height 48px
      border-radius 24px
      background rgba(92, 165, 252, 1)
      border none
      outline none
      font-size 16px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(255, 255, 255, 1)
      float right
      margin 32px 24px
      cursor pointer
    .right-content
      display inline
      width 350px
      height 300px
      margin 150px 0 0 115px
      background rgba(76, 76, 76, 0.91)
      border-radius 8px
      border 1px solid rgba(151, 151, 151, 1)
</style>
